import React, { useEffect, useRef, useState } from "react";
import { PackagePlus, Menu, X, Search } from "lucide-react";
import "./Navbar.css";
import {
  blackHeart,
  cart,
  delIcon,
  email,
  laptopCart,
  logo,
  profile,
  search,
  whatsappImg,
  headphone
} from "../../assets/imagesPath";
import { Link, NavLink, useNavigate } from "react-router-dom";
import SigninModal from "../allModals/SignupModal";
import PATHS from "../../routes/Paths";
import { useDispatch, useSelector } from "react-redux";
import LoginModal from "../allModals/loginModal";
import { userLogout } from "../../redux/AuthSlice";
import {
  useGetAllProductQuery,
  useViewCartOrdersQuery
} from "../../services/Api";
import Button from "../button/Button";
import { setSearch } from "../../redux/ProductSlice";
import { useDebounce } from "use-debounce";
import VendorloginModal from "../allModals/VendorloginModal";
import RequestProductModal from "../allModals/RequestProductModal";
import TopNavbar from "./TopNavbar";

const Navbar = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showLoginModal2, setShowLoginModal2] = useState(false);
  const [showLoginModal3, setShowLoginModal3] = useState(false);
  const [showRequestProductModal, setShowRequestProductModal] = useState(false);
  const [name, setName] = useState("");
  const [debouncedName] = useDebounce(name, 300);
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const searchRef = useRef(null);
  const navigator = useNavigate();
  const dispatch = useDispatch();
  const cartData = useSelector((data) => data?.products?.productDetail);
  const auth = useSelector((data) => data.auth);
  const [searchTxt, setSearchTxt] = useState("");
  const { isLoggedIn } = auth || {};
  const ID = auth?.userDetail?.id;
  const { data: viewCartOrders } = useViewCartOrdersQuery({
    params: { user_id: ID, order_status: 0 }
  });

  const cartRef = useRef(null);

  const signupModalHandler = () => {
    setShowLoginModal((prev) => !prev);
  };

  const requestProductModalHandler = () => {
    setShowRequestProductModal((prev) => !prev);
  };

  const loginModalHandler = () => {
    setShowLoginModal2((prev) => !prev);
  };

  const vendorLoginModalHandler = () => {
    setShowLoginModal3((prev) => !prev);
  };

  const toggleMobileSearch = () => {
    setShowMobileSearch(!showMobileSearch);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(setSearch(searchTxt));
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    // Close mobile search when menu opens
    if (!mobileMenuOpen) {
      setShowMobileSearch(false);
    }
  };

  useEffect(() => {
    if (!searchTxt) {
      dispatch(setSearch(""));
    }
  }, [searchTxt]);

  const {
    data: getAllProduct,
    refetch: getAllProductRefetch,
    loading: getAllProductLoading
  } = useGetAllProductQuery({
    params: { start: 0, limit: 100000, name: debouncedName }
  });

  useEffect(() => {
    const fetchData = async () => {
      if (debouncedName) {
        const { data } = await getAllProductRefetch();
        const filteredProducts = data?.data?.filter(
          (product) => product != null
        );
        setSearchResults(filteredProducts || []);
        setShowResults(true);
      } else {
        setSearchResults([]);
        setShowResults(false);
      }
    };
    fetchData();
  }, [debouncedName]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowResults(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {/* Top Navbar - Only show when logged in */}
      {isLoggedIn && <TopNavbar />}

      {/* Combined Main Navbar */}
      <nav className="combined-navbar">
        <div className="navbar-container">
          {/* Logo Section */}
          <div className="navbar-logo">
            <img
              src={logo}
              className="brand-logo cursor"
              onClick={() => navigator(PATHS.home)}
              alt="Logo"
            />
          </div>

          {/* Search Bar Section - Hidden on mobile by default */}
          <div
            className={`navbar-search-section ${
              showMobileSearch ? "mobile-search-active" : ""
            }`}
          >
            <div className="search-container" ref={searchRef}>
              <input
                type="text"
                className="search-input"
                placeholder="Search products..."
                value={name}
                onChange={(e) => setName(e.target.value)}
                onFocus={() => searchResults.length > 0 && setShowResults(true)}
              />
              <img src={search} className="search-icon" alt="Search" />

              {showResults && searchResults?.length > 0 && (
                <ul className="search-results">
                  {searchResults?.map((product) => (
                    <li
                      key={product?.id}
                      className="search-result-item"
                      onClick={() => {
                        navigator("/productDetails", {
                          state: { id: product?.id }
                        });
                        setShowResults(false);
                        setName("");
                      }}
                    >
                      {product?.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          {/* Desktop Navigation Links */}
          <div className="navbar-nav-desktop">
            <ul className="nav-links">
              <li>
                <NavLink to={PATHS.home} className="nav-link">
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to={PATHS.shop} className="nav-link">
                  Shop
                </NavLink>
              </li>
              <li>
                <NavLink to={PATHS.brands} className="nav-link">
                  Brands
                </NavLink>
              </li>
              <li>
                <NavLink to={PATHS.about} className="nav-link">
                  About
                </NavLink>
              </li>
              <li>
                <NavLink to={PATHS.contactUs} className="nav-link">
                  Contact
                </NavLink>
              </li>
              <li>
                <NavLink to={PATHS.blogs} className="nav-link">
                  Blogs
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Right Section - Cart, Auth, Actions */}
          <div className="navbar-right-section">
            {/* Mobile Search Toggle Button - Only show on mobile */}
            <button
              className="mobile-search-toggle"
              onClick={toggleMobileSearch}
              aria-label="Toggle search"
            >
              <Search size={20} />
            </button>

            {/* Cart - Only show when user is logged in */}
            {isLoggedIn && (
              <div
                className="cart-container"
                onClick={() => navigator(PATHS.cart)}
              >
                <div className="cart-icon-wrapper">
                  <img src={cart} alt="Cart" className="cart-icon" />
                  {viewCartOrders?.data?.order_products?.length > 0 && (
                    <span className="cart-badge">
                      {viewCartOrders?.data?.order_products?.length}
                    </span>
                  )}
                </div>
              </div>
            )}

            {/* Desktop Auth Section - Only show when NOT logged in */}
            {!isLoggedIn && (
              <div className="auth-section desktop-auth">
                <div className="auth-buttons">
                  <button
                    className="auth-btn login-btn"
                    onClick={loginModalHandler}
                  >
                    Login
                  </button>
                  <button
                    className="auth-btn vendor-btn"
                    onClick={vendorLoginModalHandler}
                  >
                    Vendor
                  </button>
                  <button
                    className="auth-btn signup-btn"
                    onClick={signupModalHandler}
                  >
                    Signup
                  </button>
                </div>
              </div>
            )}

            {/* Mobile Auth Buttons - Only show when NOT logged in */}
            {!isLoggedIn && (
              <div className="mobile-auth-buttons-top">
                <button
                  className="mobile-auth-btn-top login-btn"
                  onClick={loginModalHandler}
                >
                  Login
                </button>
                <button
                  className="mobile-auth-btn-top vendor-btn"
                  onClick={vendorLoginModalHandler}
                >
                  Vendor
                </button>
                <button
                  className="mobile-auth-btn-top signup-btn"
                  onClick={signupModalHandler}
                >
                  Signup
                </button>
              </div>
            )}

            {/* User Section - Only show when logged in */}
            {isLoggedIn && (
              <div className="user-section">
                {/* Profile Dropdown */}
                <div className="profile-dropdown">
                  <button
                    className="profile-button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src={profile} alt="Profile" className="profile-icon" />
                  </button>
                  <ul className="dropdown-menu profile-menu">
                    <li>
                      <Link to={PATHS.profile} className="dropdown-item">
                        Profile
                      </Link>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <button
                        className="dropdown-item logout-item"
                        onClick={() => dispatch(userLogout())}
                      >
                        Logout
                      </button>
                    </li>
                  </ul>
                </div>

                {/* Vendor Request Button */}
                {auth?.role === "vendor" && (
                  <button
                    className="vendor-request-button"
                    onClick={requestProductModalHandler}
                  >
                    <PackagePlus size={18} className="vendor-icon" />
                    <span className="vendor-text">Request Product</span>
                  </button>
                )}
              </div>
            )}

            {/* Contact Info Desktop */}
            <div className="contact-info-desktop">
              <img src={headphone} className="contact-icon" alt="Contact" />
              <div className="contact-text-wrapper">
                <span className="contact-label">Contact Us</span>
                <span className="contact-number">+923000828456</span>
              </div>
            </div>

            {/* Mobile Menu Toggle */}
            <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Contact Info */}
        <div className="mobile-contact-info">
          <div className="contact-item">
            <img src={whatsappImg} className="contact-icon" alt="WhatsApp" />
            <span className="contact-text">+923000828456</span>
          </div>
          <div className="contact-item">
            <img src={email} className="contact-icon" alt="Email" />
            <span className="contact-text">easyqist@gmail.com</span>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="mobile-menu">
            <div className="mobile-nav-links">
              <NavLink
                to={PATHS.home}
                className="mobile-nav-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </NavLink>
              <NavLink
                to={PATHS.shop}
                className="mobile-nav-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                Shop
              </NavLink>
              <NavLink
                to={PATHS.brands}
                className="mobile-nav-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                Brands
              </NavLink>
              <NavLink
                to={PATHS.about}
                className="mobile-nav-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </NavLink>
              <NavLink
                to={PATHS.contactUs}
                className="mobile-nav-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </NavLink>
              <NavLink
                to={PATHS.blogs}
                className="mobile-nav-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                Blogs
              </NavLink>

              {isLoggedIn && (
                <>
                  <NavLink
                    to={PATHS.profile}
                    className="mobile-nav-link"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Profile
                  </NavLink>
                  <button
                    className="mobile-nav-link logout-link"
                    onClick={() => {
                      dispatch(userLogout());
                      setMobileMenuOpen(false);
                    }}
                  >
                    Logout
                  </button>
                </>
              )}
            </div>

            {/* Mobile Auth Buttons in Menu (when not logged in) */}
            {!isLoggedIn && (
              <div className="mobile-auth-section">
                <button
                  className="mobile-auth-btn login-btn"
                  onClick={() => {
                    loginModalHandler();
                    setMobileMenuOpen(false);
                  }}
                >
                  Login
                </button>
                <button
                  className="mobile-auth-btn vendor-btn"
                  onClick={() => {
                    vendorLoginModalHandler();
                    setMobileMenuOpen(false);
                  }}
                >
                  Vendor Login
                </button>
                <button
                  className="mobile-auth-btn signup-btn"
                  onClick={() => {
                    signupModalHandler();
                    setMobileMenuOpen(false);
                  }}
                >
                  Sign Up
                </button>
              </div>
            )}

            {/* Vendor Request in Mobile */}
            {isLoggedIn && auth?.role === "vendor" && (
              <div className="mobile-vendor-section">
                <button
                  className="mobile-vendor-btn"
                  onClick={() => {
                    requestProductModalHandler();
                    setMobileMenuOpen(false);
                  }}
                >
                  <PackagePlus size={18} />
                  Request Product
                </button>
              </div>
            )}
          </div>
        )}
      </nav>

      {/* Modals */}
      {showLoginModal && (
        <SigninModal handleCloseSignupModal={signupModalHandler} />
      )}

      {showLoginModal2 && (
        <LoginModal handleCloseSignupModal={loginModalHandler} />
      )}

      {showLoginModal3 && (
        <VendorloginModal
          handleCloseVendorloginModal={vendorLoginModalHandler}
        />
      )}

      {showRequestProductModal && (
        <RequestProductModal
          handleCloseRequestProductModal={requestProductModalHandler}
        />
      )}
    </>
  );
};

export default Navbar;
